import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-delete',
  templateUrl: './context-menu-delete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuDeleteComponent {
  @Output()
  deleteClick = new EventEmitter();
}
